import Vue from 'vue';
import VueModal from 'vue-js-modal';
import { i18n, loadDefaultLanguage } from '@v4/locale/async';
import SearchPage from '@v4/search/components/pages/SearchPage.vue';
import dataLayerHandler from '@v4/common/components/mixins/data-layer-handler';
import { getJsonDataFromScript } from '@v4/common/utils/json';
import {
    modalServiceQuotesPromo,
    modalInactivity,
    modalIncentiveBanner,
} from '@v4/common/components/mixins/modal-service';
import { dkModalAware } from '@v4/common/components/mixins/modal';
import gaEventHandler from '@v4/common/components/mixins/google-analytics';
import DkReadMore from '@v4/common/components/atoms/DkReadMoreDST.vue';
import methods from '@v4/submodel-offers/methods';
import '@v4/common/utils/lazy-load';
import clickToCallModalHandler from '@v4/common/components/mixins/click-to-call-modal-handler';

(async () => {
    await loadDefaultLanguage();

    if (document.getElementById('submodel-offers')) {
        Vue.use(VueModal, { dynamic: true, injectModalsContainer: true });

        let components = {
            SearchPage,
            DkReadMore,
        };
        const fetchedData = getJsonDataFromScript('#submodel-offers-data');

        if (fetchedData.hasNews) {
            components = {
                ...components,
                DkSlide: () => ({
                    component: import(
                        /* webpackChunkName: "DkSlide-vue" */ '@v4/common/components/atoms/DkSlide/DkSlide.vue'
                    ),
                }),
                DkSlider: () => ({
                    component: import(
                        /* webpackChunkName: "DkSlider-vue" */ '@v4/common/components/molecules/DkSlider/DkSlider.vue'
                    ),
                }),
                DkNewsCard: () => ({
                    component: import(
                        /* webpackChunkName: "DkNewsCard-vue" */ '@v4/common/components/organisms/DkNewsCard.vue'
                    ),
                }),
            };
        }

        new Vue({
            el: '#submodel-offers',
            name: 'SearchPageWrapper',
            i18n,
            components,
            mixins: [
                dataLayerHandler,
                dkModalAware,
                modalServiceQuotesPromo,
                modalIncentiveBanner,
                modalInactivity,
                gaEventHandler,
                clickToCallModalHandler,
            ],
            data() {
                return {
                    fetchedData,
                };
            },
            mounted() {
                if (this.fetchedData.showClickToCallPopupTimed) {
                    this.showClickToCallPopup();
                }
            },
            methods,
        });
    }

    const yoastFaqBlockElm = document.querySelector('.wp-block-yoast-faq-block');

    if (yoastFaqBlockElm) {
        import(/* webpackChunkName: "YoastFaq" */ '@v4/common/components/organisms/YoastFaq').then(
            ({ default: YoastFaq }) => YoastFaq().init()
        );
    }

    if (document.getElementById('header')) {
        import(/* webpackChunkName: "header" */ '@v4/header').then(({ default: Header }) => Header());
    }
})();
